export default "__VITE_ASSET__tJExZwtX__"